//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const slugify = require('speakingurl');
export default {
  props: ['event'],
  methods: {
    getTeamImage: function (team_id) {
      return 'https://s3.sportify.bet/superbanner/teams/logos/'+team_id+'.png'
    },
    getCompetitionURL: function (event) {
      return this.localePath({ name: 'sport-competition', params: { competition: _.get(event, 'translated_competition_slug') } })
    },
    getURL: function (event) {
      return this.localePath({ name: 'match-screen', params: {
        sport: event?.translated_sport_slug,
        slug: slugify(event.name) + '-' + this.getEventId(event.id),
        competition: event?.translated_competition_slug,
      }})
    },
    goBack() {
      this.$router.back()
    }
  }
}
